import { User } from "../../storage/store";

// Pages for the HASHh admin account only.
export const ADMIN_PATHS = Object.freeze({
  AUTOMATION: "/admin/automation",
});

// The API's admin routes let only the account named "admin" through (adminOnly),
// so the admin pages are shown to that account alone.
export const isAdmin = () => User.getUser() === "admin";
